export const LambdaURL =
  "https://zjtvr3rz2ncske7vyartmlnryi0hpufp.lambda-url.us-east-1.on.aws/";

export const resumeUrl =
  "https://drive.google.com/file/d/1wRUCMQ853v1jAmxZyERISZZxCBNtbw0q/view?usp=sharing";

export const mediumProfileUrl = 
  "https://api.rss2json.com/v1/api.json?rss_url=https://medium.com/feed/@abisrat97";
